// Comptes Google autorisés à accéder au back-office.
// ⚠️ Cette liste est dupliquée dans firestore.rules et storage.rules (seule
// vraie protection côté serveur) : toute modification doit y être reportée,
// puis déployée avec `npm run deploy:rules`.
export const ALLOWED_EMAILS = [
  "pb.acegood@gmail.com",
  "am.acegood@gmail.com",
  "gmonfort.acegood@gmail.com",
];
